module.exports = "/static/img/html5.svg?4d65be3dae02868b574a84a95c02cb0f";